import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, AlertController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Globals } from "../../../../../globals";
import { TPVServices } from "../../../../tpv/services";
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the ConfigurationRoomsCreateTablePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-configuration-rooms-create-table',
    templateUrl: 'configuration-rooms-create-table.html',
})
export class ConfigurationRoomsCreateTablePage {

    public form_table: FormGroup;
    update_state: boolean = false;
    public room_uid: any;
    public table: any;
    public room_name: any;
    public order: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public fb: FormBuilder,
        private toastCtrl: ToastController,
        public tpvServices: TPVServices,
        public globals: Globals,
        private alertCtrl: AlertController,
        public translate: TranslateService) {

        //Params
        this.update_state = this.navParams.get('update');
        this.room_uid = this.navParams.get('room_uid');
        this.room_name = this.navParams.get('room_name');

        if (this.navParams.get('update')) {
            this.table = this.navParams.get('table');

            if (!this.table.order) {
                this.table.order = 0;
            }

            this.form_table = fb.group({
                name: [this.table.name, Validators.compose([Validators.required])],
                persons: [this.table.persons, Validators.compose([Validators.required])],
                size: [this.table.size, Validators.compose([Validators.required])],
                cash_static: [this.table.cash_static + ' | ' + this.table.cash_uid, Validators.compose([Validators.required])],
                order: [this.table.order, Validators.compose([Validators.required])],
                map_style: [this.table.map_style, Validators.compose([Validators.required])],
            });

        } else {
            this.form_table = fb.group({
                name: ['', Validators.compose([Validators.required])],
                persons: [0, Validators.compose([Validators.required])],
                size: ['', Validators.compose([Validators.required])],
                cash_static: ['', Validators.compose([Validators.required])],
                order: [0, Validators.compose([Validators.required])],
                map_style: ['dnd-square', Validators.compose([Validators.required])],
            });
        }



        this.tpvServices.getCashs(this.globals.restaurant_uid);
    }


    submit() {
        if (this.form_table.valid) {
            if (this.form_table.value.size == '') {
            } else if (this.form_table.value.cash_static == '') {
            } else {
                if (!this.update_state) {
                    this.insert();
                } else {
                    this.update();
                }
            }
        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('instant-introduce-todos-valores-mesa-continuar'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }

    insert() {
        var cash_split = this.form_table.value.cash_static.split('|');
        var cash_name = cash_split[0];
        var cash_uid = cash_split[1];
        this.tpvServices.afs.collection('tables').add({
            'UID_RESTAURANT': this.globals.restaurant_uid,
            'cash_static': cash_name.trim(),
            'cash_uid': cash_uid.trim(),
            'customer': {},
            'discount_type': '',
            'discount_value': 0,
            'name': this.form_table.value.name,
            'persons': this.form_table.value.persons,
            'size': this.form_table.value.size,
            'state': 'open',
            'ticket': {
                'amount': 0,
                'date': '',
                list: {},
                'number': '',
                'payment': false,
                'payment_type': '',
                'waiter': '',
                'waiter_uid': '',
                'updated_at': new Date(),
                'tip': 0
            },
            'type': 'table',
            'uid_room': this.room_uid,
            'map_style': this.form_table.value.map_style,
            'map_top': 0,
            'map_left': 0,
            'room': this.room_name,
            'order': this.form_table.value.order,
            'notes': '',
        }).then(doc => {
            this.globals.GAtrackView('Configuration', 'Configuration - Rooms - Table - Create', this.globals.restaurant.email, 'Create/Update', 'Create table room', 'Configuration', this.form_table.value.name);
            this.navCtrl.pop();
        });
    }

    update() {
        var cash_split = this.form_table.value.cash_static.split('|');
        var cash_name = cash_split[0];
        var cash_uid = cash_split[1];

        this.tpvServices.afs.collection('tables').doc(this.table.UID).update({
            'cash_static': cash_name.trim(),
            'cash_uid': cash_uid.trim(),
            'name': this.form_table.value.name,
            'persons': this.form_table.value.persons,
            'size': this.form_table.value.size,
            'order': this.form_table.value.order,
            'map_style': this.form_table.value.map_style,
        }).then(() => {
            this.globals.GAtrackView('Configuration', 'Configuration - Rooms - Table - Update', this.globals.restaurant.email, 'Create/Update', 'Update table room', 'Configuration', this.form_table.value.name);
            this.navCtrl.pop();
        });
    }

    delete() {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('instant-eliminar-mesa'),
            message: this.translate.instant('instant-seguro-quieres-eliminarla'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => { }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.globals.GAtrackView('Configuration', 'Configuration - Rooms - Table - Delete', this.globals.restaurant.email, 'Delete', 'Delete table room', 'Configuration', this.table.name);
                        this.tpvServices.afs.doc('tables/' + this.table.UID).delete();
                        this.navCtrl.pop();
                    }
                }
            ]
        });
        alert.present();

    }

}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-rooms/configuration-rooms-create/configuration-rooms-create-table/configuration-rooms-create-table.ts